import { useCallback, useEffect, useState } from "react";
import * as api from "../../../utils/api/deliveryDocumentation";
import { OUTCOME_LABELS } from "../../../utils/cashier/deliveryDocumentation";
import { Button, Eye } from "../../ui";
import { AdminPagination, RetryButton } from "./AdminUi";
import { useAppLabel } from "../../../utils/useAppLabel";

export default function DeletedOrders({ filters, onOpenOrder }) {
  const appLabel = useAppLabel();
  const [state, setState] = useState({
    loading: true,
    error: "",
    items: [],
    pagination: { page: 1 },
  });
  const load = useCallback(
    async (page = 1) => {
      setState((value) => ({ ...value, loading: true, error: "" }));
      try {
        const data = await api.getAdminDeletedOrders({
          ...filters,
          page,
          limit: 20,
        });
        setState({
          loading: false,
          error: "",
          items: data.items || [],
          pagination: data.pagination || {},
        });
      } catch (error) {
        setState((value) => ({
          ...value,
          loading: false,
          error: error.message,
        }));
      }
    },
    [filters],
  );
  useEffect(() => {
    load(1);
  }, [load]);
  if (state.loading)
    return <div className="admin-empty">جاري تحميل الطلبات المحذوفة…</div>;
  if (state.error)
    return (
      <div className="admin-empty admin-error">
        {state.error}{" "}
        <RetryButton onClick={() => load(state.pagination.page || 1)} />
      </div>
    );
  if (!state.items.length)
    return (
      <div className="admin-empty">
        لا توجد طلبات محذوفة حسب الفلاتر الحالية.
      </div>
    );
  return (
    <>
      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>الطلب</th>
              <th>المطعم</th>
              <th>الفرع</th>
              <th>التطبيق</th>
              <th>تاريخ العمل</th>
              <th>الحالة</th>
              <th>الحذف</th>
              <th>الأدلة</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {state.items.map((order) => (
              <tr key={order._id}>
                <td dir="ltr">#{order.last4}</td>
                <td>{order.storeSnapshot?.name}</td>
                <td>{order.branchSnapshot?.name}</td>
                <td>
                  {appLabel(
                    order.applicationSnapshot?.app,
                    order.applicationSnapshot?.name,
                  )}
                </td>
                <td>{order.businessDate}</td>
                <td>{OUTCOME_LABELS[order.outcome] || order.outcome}</td>
                <td>
                  {order.deletedAt
                    ? new Date(order.deletedAt).toLocaleString("ar-SA")
                    : "محذوف"}
                </td>
                <td>
                  {Object.keys(order.evidence || {}).length} حالي ·{" "}
                  {order.evidenceHistory?.length || 0} تاريخي
                </td>
                <td>
                  <Button
                    variant="primary"
                    appearance="filled"
                    size="sm"
                    type="button"
                    icon={<Eye size={13}/>}
                    onClick={() => onOpenOrder(order._id)}/>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <AdminPagination
        page={state.pagination.page}
        totalPages={state.pagination.totalPages}
        hasPreviousPage={state.pagination.hasPreviousPage}
        hasNextPage={state.pagination.hasNextPage}
        onPrevious={() => load(state.pagination.page - 1)}
        onNext={() => load(state.pagination.page + 1)}
      />
    </>
  );
}
